/**
 * TEMP: every print-settings page this bundle can render, keyed by its CMS page key
 * (must match layoutPageComponents). Until each page-module row is seeded under the
 * print-settings group, the missing ones are injected into the group's `subPage` so they
 * show as tabs and get routes. Pages already in the tree are left untouched.
 * Delete this file (and its two call sites in StockLayout's reformat) once the rows exist.
 */
export const TEMP_PRINT_SETTINGS_PAGES = [
    { key: 'purchaseInvoicePrintSettings', slug: 'purchase-invoice-print-settings', svgKey: 'print' },
    { key: 'poInvoicePrintSettings', slug: 'purchase-order-print-settings', svgKey: 'print' },
    { key: 'transferPrint', slug: 'transfer-print-settings', svgKey: 'print' },
    { key: 'wastagePrint', slug: 'wastage-print-settings', svgKey: 'print' },
    { key: 'printStockCount', slug: 'stock-count-print-settings', svgKey: 'print' },
    // Reached at /stock-app/print-settings/production until the `printProduction` row is seeded.
    { key: 'printProduction', slug: 'production', svgKey: 'print' },
    { key: 'labelPrintSettings', slug: 'label-print-settings', svgKey: 'print' },
    { key: 'quotationPrintSettings', slug: 'quotation-print-settings', svgKey: 'print' },
    { key: 'salesPrintSettings', slug: 'sales-print-settings', svgKey: 'print' },
    { key: 'kitchenOrderPrintSettingsB2b', slug: 'kitchen-order-print-settings', svgKey: 'print' },
    { key: 'customerStatementPrintSettings', slug: 'customer-statement-print-settings', svgKey: 'print' },
    { key: 'printSupplierStatementSettings', slug: 'statement-print-settings', svgKey: 'print' },
    // Product labels and the customer receipt are POS print designs (POS › Print Network, served by the
    // admin shell) since RESTOAPP-7366 — never injected here.
]

/** Same test SettingsLayout uses to pick StockPrintLayout for a sub-layout. */
export const isPrintSettingsLayout = (layout) =>
    layout?.pageType === 'layout' && /print/i.test(`${layout?.key || ''} ${layout?.route || ''}`)

const collectKeys = (nodes, set = new Set()) => {
    ;(nodes || []).forEach((node) => {
        if (node?.key) set.add(node.key)
        if (node?.subPage?.length) collectKeys(node.subPage, set)
    })
    return set
}

const collectRoutes = (nodes, set = new Set()) => {
    ;(nodes || []).forEach((node) => {
        if (node?.route) set.add(String(node.route).replace(/\/$/, ''))
        if (node?.subPage?.length) collectRoutes(node.subPage, set)
    })
    return set
}

/** Returns the layout with any missing print-settings pages appended as tab pages. */
export const withTempPrintSettingsPages = (layout) => {
    if (!isPrintSettingsLayout(layout) || !layout.route) return layout
    const existing = collectKeys(layout.subPage)
    // A page already seeded at the same route under an older key (`productionPrintSettings` at
    // .../production) must not get a second tab from its new key.
    const existingRoutes = collectRoutes(layout.subPage)
    const base = String(layout.route).replace(/\/$/, '')
    const maxOrder = (layout.subPage || []).reduce((m, p) => (typeof p?.order === 'number' && p.order > m ? p.order : m), 0)
    const injected = TEMP_PRINT_SETTINGS_PAGES
        .filter((p) => !existing.has(p.key) && !existingRoutes.has(`${base}/${p.slug}`))
        .map((p, i) => ({
            uuid: `temp-print-${p.key}`,
            key: p.key,
            route: `${base}/${p.slug}`,
            svgKey: p.svgKey,
            type: 'hor',
            pageType: 'page',
            isActive: true,
            isPopup: false,
            order: maxOrder + i + 1,
            // No grants of its own yet — reuse the group's, like the old hardcoded TEMP routes did.
            access: layout.access,
            subPage: [],
        }))
    if (injected.length === 0) return layout
    return { ...layout, subPage: [...(layout.subPage || []), ...injected] }
}
